module.exports = __webpack_public_path__ + "img/Triomphe.ffe2e04f.png";